var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 12C22 17.524 17.523 22 12 22C6.477 22 2 17.524 2 12C2 6.478 6.477 2 12 2C17.523 2 22 6.478 22 12Z",
    fill: "#FF0909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 14.9287C12.4871 14.9287 12.8791 15.3217 12.8791 15.8037C12.8791 16.2857 12.4871 16.6787 12.0041 16.6787C11.5191 16.6787 11.1241 16.2857 11.1241 15.8037C11.1241 15.3217 11.5151 14.9287 11.9941 14.9287ZM11.9941 7.33594C12.4761 7.33594 12.8691 7.72894 12.8691 8.21094V12.6309C12.8691 13.1129 12.4761 13.5059 11.9941 13.5059C11.5121 13.5059 11.1191 13.1129 11.1191 12.6309V8.21094C11.1191 7.72894 11.5121 7.33594 11.9941 7.33594Z",
    fill: "#FF0909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle24);
export default __webpack_public_path__ + "static/media/info-circle-24.7ab0efc9e51e42d149ea1020834df837.svg";
export { ForwardRef as ReactComponent };